import React from 'react';
import { ReactComponent as ScrollIcon } from '../../../assets/common/scroll_icon.svg';
import './ScrollTooltip.scss';

import clsx from 'clsx';

interface ScrollTooltipProps {
  className?: string;
  showText?: boolean;
  text?: string;
  onClick?: () => void;
}

export const ScrollTooltip: React.FC<ScrollTooltipProps> = ({
  className = '',
  showText = true,
  text = 'Scroll',
  onClick = () => {},
}) => {
  return (
    <div className={clsx('scroll-tooltip', className)} onClick={onClick}>
      <ScrollIcon className="scroll-tooltip__icon" />
      {showText && <span className="scroll-tooltip__text">{text}</span>}
    </div>
  );
};

export default ScrollTooltip;
